import AccessCreate from "../components/AccessCreate";
import {connect} from "react-redux";
import {createAdmin} from "../actions/userActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_CREATE_ACCESS} from "../actions";
import {push} from "react-router-redux";

const m2s = state => ({
	isCreating: isProcessing(state, PROC_CREATE_ACCESS)
});

const m2d = dispatch => ({
	onCreate: (data, success) => dispatch(createAdmin(data, success)),
	onPush: (where) => dispatch(push(where))
});

export default connect(m2s, m2d)(AccessCreate);


// WEBPACK FOOTER //
// ./src/containers/AccessCreateController.js